import { Injectable, OnDestroy } from '@angular/core';
import { AnexoLoaService } from '../service/anexo-loa.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FuncaoService, LoginContabil, Exercicio, Relatorio, GlobalService } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class Anexo10 implements OnDestroy {

  protected funcaoService: FuncaoService;
  private login: LoginContabil = new LoginContabil();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected anexoServico: AnexoLoaService) {
    this.funcaoService = new FuncaoService();
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // tslint:disable: max-line-length
  public montarRelatorio(exercicio: Exercicio, orgaos: number[]) {
    this.anexoServico.obterAnexo10(exercicio.id, orgaos, this.login.ppa.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('', this.login.usuario.nome, this.login.usuario.sobrenome,
          this.login.orgao.nome, this.login.brasao, this.conteudo(dados, exercicio),
          'landscape', 'ANEXO X - LEI 4.320/64',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, null, true);
      });
  }

  private conteudo(dados: any[], exercicio: Exercicio): {}[] {
    let totalOrcado = 0;
    let totalArrecadado = 0;

    // monta o cabecalho
    const registros: {}[] = [
      [{ text: `ANEXO X - LEI 4.320/64 - Exercício: ${exercicio.ano}`, alignment: 'center', bold: true, fontSize: 11, colSpan: 5, border: [false, false, false, false] }, '', '', '', ''],
      [{ text: 'COMPARATIVO DA RECEITA ORÇADA COM A ARRECADADA', alignment: 'center', bold: true, fontSize: 11, colSpan: 5, border: [true, true, true, true] }, '', '', '', ''],
      [
        { text: 'DESCRIÇÃO', alignment: 'center', bold: true, fontSize: 9, rowSpan: 2, margin: [0, 8, 0, 0], border: [true, true, true, true] },
        { text: 'ORÇADA', alignment: 'center', bold: true, fontSize: 9, rowSpan: 2, margin: [0, 8, 0, 0], border: [true, true, true, true] },
        { text: 'ARRECADADA', alignment: 'center', bold: true, fontSize: 9, rowSpan: 2, margin: [0, 8, 0, 0], border: [true, true, true, true] },
        { text: 'DIFERENÇAS', alignment: 'center', bold: true, fontSize: 9, colSpan: 2, border: [true, true, true, true] }, ''
      ],
      ['', '', '',
        { text: 'PARA MAIS', alignment: 'center', bold: true, fontSize: 9, border: [true, true, true, true] },
        { text: 'PARA MENOS', alignment: 'center', bold: true, fontSize: 9, border: [true, true, true, true] },
      ],
    ];

    // 10000000
    const gruposClassificacao = this.funcaoService.agrupar(dados, ['classificacao_codigo', 'classificacao_nome'], ['valor_orcado', 'valor_arrecadado']);
    for (const classificacao of gruposClassificacao) {
      if (+classificacao.totalizadores['valor_arrecadado'] === 0 && +classificacao.totalizadores['valor_orcado'] === 0) continue;

      const diferencaClassificacao = +classificacao.totalizadores['valor_arrecadado'] - +classificacao.totalizadores['valor_orcado'];
      registros.push([
        { text: `${classificacao.grupo['classificacao_codigo']} - ${classificacao.grupo['classificacao_nome']}`, bold: true, fontSize: 9, border: [true, false, true, false] },
        { text: this.funcaoService.convertToBrNumber(classificacao.totalizadores['valor_orcado'], 2), alignment: 'right', bold: true, fontSize: 9, border: [true, false, true, false] },
        { text: this.funcaoService.convertToBrNumber(classificacao.totalizadores['valor_arrecadado'], 2), alignment: 'right', bold: true, fontSize: 9, border: [true, false, true, false] },
        { text: this.funcaoService.convertToBrNumber(diferencaClassificacao > 0 ? diferencaClassificacao : 0, 2), alignment: 'right', bold: true, fontSize: 9, border: [true, false, true, false] },
        { text: this.funcaoService.convertToBrNumber(diferencaClassificacao < 0 ? diferencaClassificacao * -1 : 0, 2), alignment: 'right', bold: true, fontSize: 9, border: [true, false, true, false] },
      ]);

      totalOrcado += +classificacao.totalizadores['valor_orcado'];
      totalArrecadado += +classificacao.totalizadores['valor_arrecadado'];

      // 11110000
      const gruposSub = this.funcaoService.agrupar(classificacao.registros, ['sub_codigo', 'sub_nome'], ['valor_orcado', 'valor_arrecadado']);
      for (const sub of gruposSub) {
        if (+sub.totalizadores['valor_arrecadado'] === 0 && +sub.totalizadores['valor_orcado'] === 0) continue;

        const diferencaSub = +sub.totalizadores['valor_arrecadado'] - +sub.totalizadores['valor_orcado'];
        registros.push([
          { text: `${sub.grupo['sub_codigo']} - ${sub.grupo['sub_nome']}`, decoration: 'underline', fontSize: 9, margin: [10, 0, 0, 0], border: [true, false, true, false] },
          { text: this.funcaoService.convertToBrNumber(sub.totalizadores['valor_orcado'], 2), alignment: 'right', decoration: 'underline', fontSize: 9, border: [true, false, true, false] },
          { text: this.funcaoService.convertToBrNumber(sub.totalizadores['valor_arrecadado'], 2), alignment: 'right', decoration: 'underline', fontSize: 9, border: [true, false, true, false] },
          { text: this.funcaoService.convertToBrNumber(diferencaSub > 0 ? diferencaSub : 0, 2), alignment: 'right', decoration: 'underline', fontSize: 9, border: [true, false, true, false] },
          { text: this.funcaoService.convertToBrNumber(diferencaSub < 0 ? diferencaSub * -1 : 0, 2), alignment: 'right', decoration: 'underline', fontSize: 9, border: [true, false, true, false] },
        ]);

        for (const receita of sub.registros) {
          if (+receita.valor_arrecadado === 0 && +receita.valor_orcado === 0) continue;

          const diferencaReceita = +receita.valor_arrecadado - +receita.valor_orcado;
          registros.push([
            { text: `${receita.codigo} - ${receita.nome_receita}`, fontSize: 9, margin: [20, 0, 0, 0], border: [true, false, true, false] },
            { text: this.funcaoService.convertToBrNumber(receita.valor_orcado, 2), alignment: 'right', fontSize: 9, border: [true, false, true, false] },
            { text: this.funcaoService.convertToBrNumber(receita.valor_arrecadado, 2), alignment: 'right', fontSize: 9, border: [true, false, true, false] },
            { text: this.funcaoService.convertToBrNumber(diferencaReceita > 0 ? diferencaReceita : 0, 2), alignment: 'right', fontSize: 9, border: [true, false, true, false] },
            { text: this.funcaoService.convertToBrNumber(diferencaReceita < 0 ? diferencaReceita * -1 : 0, 2), alignment: 'right', fontSize: 9, border: [true, false, true, false] },
          ]);
        }
      }
    }

    const diferencaGeral = totalArrecadado - totalOrcado;
    registros.push([
      { text: 'TOTAL GERAL:', bold: true, fontSize: 9, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(totalOrcado, 2), bold: true, alignment: 'right', fontSize: 9, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(totalArrecadado, 2), bold: true, alignment: 'right', fontSize: 9, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(diferencaGeral > 0 ? diferencaGeral : 0, 2), bold: true, alignment: 'right', fontSize: 9, border: [true, true, true, true] },
      { text: this.funcaoService.convertToBrNumber(diferencaGeral < 0 ? diferencaGeral * -1 : 0, 2), bold: true, alignment: 'right', fontSize: 9, border: [true, true, true, true] },
    ]);

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 4,
        widths: ['*', 80, 80, 76, 76],
        body: registros
      }
    }];
  }

}
